module.exports = __webpack_public_path__ + "img/avatar.50b10841.png";